import Navbar from "../../../components/feature/Navbar";
import Footer from "../../../components/feature/Footer";
import RCArticleHero from "./components/RCArticleHero";
import RCArticleContentFirstHalf from "./components/RCArticleContentFirstHalf";
import RCArticleContentSecondHalf from "./components/RCArticleContentSecondHalf";
import RCArticleFormula from "./components/RCArticleFormula";
import RCArticleRelated from "./components/RCArticleRelated";
import RCArticleBottomCTA from "./components/RCArticleBottomCTA";

export default function ReadingCornerPage() {
  return (
    <div className="min-h-screen bg-[#FDFAF5]" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <main>
        <RCArticleHero />
        <div className="max-w-screen-xl mx-auto px-8 md:px-16">
          <RCArticleContentFirstHalf />
          <RCArticleContentSecondHalf />
          <RCArticleFormula />
        </div>
        <RCArticleRelated />
        <RCArticleBottomCTA />
      </main>
      <Footer />
    </div>
  );
}
